export default __webpack_public_path__ + "static/media/formal-mini.464d53e7.jpg";